import type { MutableRefObject } from "react";

const DEFAULT_WINDOW_MS = 400;

/**
 * Returns true when this open should be ignored — same row within `windowMs`
 * (e.g. custom touch long-press then native `contextmenu`, or list row remount losing hook refs).
 */
export function shouldSuppressDuplicateContextMenuOpen(
    lastOpenRef: MutableRefObject<{ nodeId: number; at: number } | null>,
    nodeId: number,
    windowMs: number = DEFAULT_WINDOW_MS,
): boolean {
    const now =
        typeof performance !== "undefined" && typeof performance.now === "function" ? performance.now() : Date.now();
    const prev = lastOpenRef.current;
    if (prev && prev.nodeId === nodeId && now - prev.at < windowMs) {
        return true;
    }
    lastOpenRef.current = { nodeId, at: now };
    return false;
}
